<fgb-mobile-page-header [pageTitle]="'offers.page.title'" backButtonLink="/" [showQr]="false" [showBalance]="false" />
<fgb-banner class="d-lg-block d-none" [title]="'offers.page.title' | translate" />

<fgb-endurance-zone></fgb-endurance-zone>
